import { ProfileCategoryRequests } from '@/services/profile-category.requests'
const profileCategoryService = new ProfileCategoryRequests()

const state = {
  list: []
}
const getters = {}

const actions = {
  list ({ state }) {
    return new Promise((resolve, reject) => {
      profileCategoryService.list().then(async (profileCategories) => {
        state.list = profileCategories
        resolve(profileCategories)
      }).catch((error) => {
        reject(error)
      })
    })
  }
}

const mutations = {}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
